// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor_principal_per_preguntas{
    display:flex;
    flex-direction: column;
    align-items: center; /* Centra horizontalmente */
    justify-content: center; /* Centra verticalmente */
    text-align: center;
    margin-top: 50px;
    margin-bottom: 100px;
    padding: 20px;
}

.preguntas_por_examen_2 {
    font: 1.4em Gupter;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    border: double 7px white;
    background-color:#a2d1e0;
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.preguntas_por_temas_2 {
    font: 1.4em Gupter;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    border: double 7px white;
    background-color:#a2d1e0;
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.separacion_p {
    margin-top: 10px;
    margin-bottom: 10px;
}

button.boton_per
{
    margin-top: 20px;
    color: white;
    background-color: rgb(170, 157, 152);
    padding: 10px;
    border-radius: 20px;
    border: double 7px #a2d1e0;
    font-style: bold;
}

.advertencia
{
    font: 1em Gupter;
    color: #333;
    font-style: bold;
}

button.boton_per_2
{
    margin-top: 20px;
    color: white;
    background-color: rgb(34, 118, 148);
    padding: 10px;
    border-radius: 20px;
    border: double 7px #a2d1e0;
    font-style: bold;
}

.titulo_t {
    font: 1.8em Gupter;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: white;
    background-color: #545454;
    border: double 7px white;
    border-radius: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.conjunto_p {
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/css/Preguntas_PER.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB,EAAE,2BAA2B;IAChD,uBAAuB,EAAE,yBAAyB;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,uBAAuB;AAC3B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap\");\r\n\r\n.contenedor_principal_per_preguntas{\r\n    display:flex;\r\n    flex-direction: column;\r\n    align-items: center; /* Centra horizontalmente */\r\n    justify-content: center; /* Centra verticalmente */\r\n    text-align: center;\r\n    margin-top: 50px;\r\n    margin-bottom: 100px;\r\n    padding: 20px;\r\n}\r\n\r\n.preguntas_por_examen_2 {\r\n    font: 1.4em Gupter;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    border: double 7px white;\r\n    background-color:#a2d1e0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n    border-radius: 20px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.preguntas_por_temas_2 {\r\n    font: 1.4em Gupter;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    border: double 7px white;\r\n    background-color:#a2d1e0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n    border-radius: 20px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.separacion_p {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\nbutton.boton_per\r\n{\r\n    margin-top: 20px;\r\n    color: white;\r\n    background-color: rgb(170, 157, 152);\r\n    padding: 10px;\r\n    border-radius: 20px;\r\n    border: double 7px #a2d1e0;\r\n    font-style: bold;\r\n}\r\n\r\n.advertencia\r\n{\r\n    font: 1em Gupter;\r\n    color: #333;\r\n    font-style: bold;\r\n}\r\n\r\nbutton.boton_per_2\r\n{\r\n    margin-top: 20px;\r\n    color: white;\r\n    background-color: rgb(34, 118, 148);\r\n    padding: 10px;\r\n    border-radius: 20px;\r\n    border: double 7px #a2d1e0;\r\n    font-style: bold;\r\n}\r\n\r\n.titulo_t {\r\n    font: 1.8em Gupter;\r\n    display: flex;\r\n    text-align: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-weight: bold;\r\n    color: white;\r\n    background-color: #545454;\r\n    border: double 7px white;\r\n    border-radius: 20px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.conjunto_p {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
